import * as React from 'react';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import classNames from 'classnames';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';

import type { ProfileDefault } from '../../../../types/uncinc_profile/profile';

import './style.scss';

interface ProfileProps extends React.HTMLProps<React.HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ProfileDefault>;
  classes: string;
}

const ProfileImage = ({ src, alt }: { src: string[], alt: string; }) => (
  <div className="ProfileTeaser__image ">
    <div className="ProfileTeaser__image__placeholder icon-after icon-search icon-variant-1" />
    <Image
      src={src}
      alt={alt}
    />
  </div>
);

const ProfileTeaser: React.FC<ProfileProps> = ({ entity, classes }) => {
  const profile = entity.toJS();
  const profileFirstName = profile.field_first_name[0].value;
  const profileLastName = profile.field_first_name[0].value;
  const fullName = [profileFirstName, profileLastName].concat(' ') as unknown as string;
  const profileDescription = profile.field_description?.[0]?.processed;
  const profileEmail = profile.field_email_address?.[0]?.value;
  const profileFunctions = profile.field_functions;
  const imageStyles = profile.field_media_item?.[0]?.styles;
  // #TODO add link once available
  const url = '#';
  const telephone = profile.field_telephone?.[0]?.value;

  const src = [
    `${imageStyles?.ratio_1_1_sm ?? ''}`,
  ];

  return (
    <div className={classNames('ProfileTeaser', classes)}>

      <div className="ProfileTeaser__imageDesktop">
        <ProfileImage src={src} alt={fullName} />
      </div>

      <div className="ProfileTeaser__description">
        <div className="ProfileTeaser__header">

          <div className="ProfileTeaser__imageMobile">
            <ProfileImage src={src} alt={fullName} />
          </div>

          <div className="ProfileTeaser__nameHeader">
            <div className="ProfileTeaser__nameHeader__name">{profileFirstName} {profileLastName}</div>
            {(profileFunctions && profileFunctions.length > 0) && (
              <div className="ProfileTeaser__nameHeader__function">
                {profileFunctions.map(
                  (profileFunction) => <span>{profileFunction.entity.name[0].value}</span>,
                )}
              </div>
            )}
          </div>
        </div>

        {profileDescription && (
          <div className="ProfileTeaser__content">
            <p>{profileDescription}</p>
          </div>
        )}

        {(telephone || profileEmail || profileDescription) && (
          <div className="ProfileTeaser__links">
            {telephone && <CoreLink href={`tel:${telephone}`}><span className="icon icon-phone" /> {telephone}</CoreLink>}
            {profileEmail && <CoreLink href={`mailto:${profileEmail}`}><span className="icon icon-mail" /> Mail {profileFirstName}</CoreLink>}
            {profileDescription && <CoreLink href={url}><span className="icon icon-comment" />Bio</CoreLink>}
          </div>
        )}

      </div>
    </div>
  );
};

export default ProfileTeaser;

